var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03906 19.5986H19.1279C20.6748 19.5986 21.5449 18.7197 21.5449 17.0234V7.31152C21.5449 5.62402 20.666 4.74512 18.9609 4.74512H4.86328C3.31641 4.74512 2.44629 5.61523 2.44629 7.31152V17.0234C2.44629 18.7285 3.3252 19.5986 5.03906 19.5986ZM10.9541 12.7783L4.08105 6.01074C4.31836 5.86133 4.63477 5.78223 5.0127 5.78223H18.9785C19.374 5.78223 19.6992 5.87012 19.9541 6.0459L13.1074 12.7783C12.7295 13.1562 12.3691 13.3057 12.0264 13.3057C11.6924 13.3057 11.3232 13.1387 10.9541 12.7783ZM3.4834 17.0146V7.32031C3.4834 7.16211 3.50098 7.02148 3.52734 6.88965L8.96777 12.2246L3.53613 17.5156C3.50098 17.3662 3.4834 17.1992 3.4834 17.0146ZM20.5078 7.32031V17.0234C20.5078 17.1816 20.4902 17.3311 20.4639 17.4629L15.0938 12.2246L20.4814 6.95117C20.499 7.06543 20.5078 7.18848 20.5078 7.32031ZM5.0127 18.5527C4.66113 18.5527 4.37109 18.4912 4.13379 18.3594L9.68848 12.9277L10.3389 13.5693C10.9102 14.1318 11.4727 14.3516 12.0264 14.3516C12.5801 14.3516 13.1426 14.1318 13.7227 13.5693L14.373 12.9277L19.8926 18.333C19.6553 18.4824 19.3477 18.5527 18.9785 18.5527H5.0127Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.8c8915d9b86d1a8b63d9306e99285f8e.svg";
export { ForwardRef as ReactComponent };